import { render, staticRenderFns } from "./staffsalaries.vue?vue&type=template&id=0c2e5d54&"
import script from "./staffsalaries.vue?vue&type=script&lang=js&"
export * from "./staffsalaries.vue?vue&type=script&lang=js&"
import style0 from "./staffsalaries.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports